import { Component, Input, OnInit } from '@angular/core';
import { IROPS_STATUS } from '@app/enums/irops.enum';
import { FlightSummary, Segment } from '@app/models/micro';
import {
  calculateIropsAffectationTime,
  calculateTimeFlight,
  getSabreArrivalDate,
  getSabreDepartureDate,
  getSegmentArrivalDate,
  getSegmentDepartureDate,
  isSegmentDelayedOrEarly,
  parseTime,
} from '@app/utils/functions/srIrops';

@Component({
    selector: 'itinerary-no-elegible',
    templateUrl: './itinerary-no-elegible.component.html',
    styleUrls: ['./itinerary-no-elegible.component.scss'],
    standalone: false
})
export class ItineraryNoElegibleComponent implements OnInit {

  @Input() flightSummary: FlightSummary;
  @Input() statusIrops: IROPS_STATUS;

  segModify: any[] = [];
  segNotModify: any = [];
  firstSegment: Segment;
  lastSegment: Segment;
  firstAfected: Segment;
  lastAfected: Segment;
  lineRoute: number;
  firstAfectedTime: any;
  scales: any[] = [];
  isAfectedFirstSeg: boolean;
  isAfectedLastSeg: boolean;
  segments: Segment[];

  constructor() { }

  ngOnInit() {
    this.segments = this.flightSummary?.segments;
    this.segmentsAfected();
  }

  segmentsAfected() {
    this.segments?.forEach((segment, index) => {
      if (isSegmentDelayedOrEarly(segment)) {
        this.segModify.push(segment);
      } else {
        const cityCode1 = segment?.departureAirport;
        const cityCode2 = segment?.arrivalAirport;

        this.segNotModify.push(`${cityCode1}-${cityCode2}`);
      }

      if (index > 0 && index <= (this.segments?.length - 1)) {
        this.scales.push({
          iataDeparture: segment?.departureAirport,
          isAffected: isSegmentDelayedOrEarly(segment),
        });
      }
    });

    this.firstSegment = this.segments[0];
    this.lastSegment = this.segments[this.segments?.length - 1];

    this.firstAfected = this.segModify[0];
    this.lastAfected = this.segModify?.length > 0 ? this.segModify[this.segModify?.length - 1] : null;

    this.isAfectedFirstSeg = isSegmentDelayedOrEarly(this.firstSegment);
    this.isAfectedLastSeg = isSegmentDelayedOrEarly(this.lastSegment);

    if (this.firstAfected) {
      this.firstAfectedTime = calculateIropsAffectationTime(this.firstAfected);
    }

    this.lineRoute = this.getLinea(this.segments);
  }

  get dateDeparture() {
    return getSabreDepartureDate(this.firstSegment);
  }

  get dateArrival() {
    return getSabreArrivalDate(this.lastSegment);
  }

  get timeItinerary() {
    return parseTime(
      getSabreDepartureDate(this.firstSegment),
      getSabreArrivalDate(this.lastSegment)
    );
  }

  get timeConnecting() {
    return calculateTimeFlight(
      getSegmentArrivalDate(this.firstSegment),
      getSegmentDepartureDate(this.lastSegment)
    );
  }

  get duration() {
    return calculateTimeFlight(
      getSabreDepartureDate(this.firstSegment),
      getSabreArrivalDate(this.lastSegment)
    );
  }

  getLinea(segments) {
    if (segments.length == 1) {
      return 2;
    } else if (segments.length == 2) {
      return 3;
    } else if (segments.length > 2) {
      return 4;
    } else {
      return 0;
    }
  }

}